import { IResourceComponentsProps, useImport, useCreateMany, useGetIdentity, useNavigation } from '@pankod/refine-core'

import {
  List,
  RefreshButton,
  CreateButton,
  ExportButton,
  Table,
  useTable,
  Space,
  EditButton,
  DeleteButton,
  DateField,
  getDefaultSortOrder,
  useModalForm,
  Icons,
  Tag,
  ImportButton,
  Typography,
  ShowButton,
  Button,
  message,
  Popconfirm,
  Row,
  Col,
  Input,
} from '@pankod/refine-antd'
import './style.css'

import { IEvaluationMain, IGrade } from 'interfaces'
import React, { useEffect, useState, useMemo } from 'react'
import { getPaperById } from 'gql/query'
import { CreateEvaluation } from 'pages/evaluations'
import Permissions from 'permissions'
import { useUserContext } from 'context/user'
import { deleteEvaluationDetails } from 'gql/mutations'
type Permission = {
  granted?: boolean
}

const { PlusOutlined, DeleteOutlined } = Icons

type Evaluation = {
  candidate_id: string
  candidate_name: string
  application_id: string
  candidate_image: string
  total_score: number
  answers: object[]
  created_by: string
  paper_id: string
}
type QuestionAnswer = {
  id: string
  number: number
  option: string
  mark: number
}
type Props = {
  record: any
}
export const EvaluationList: React.FC<Props> = ({ record }) => {
  const persistSearch = !record?.id
  const { mutate } = useCreateMany<IEvaluationMain>()
  const { data: user } = useGetIdentity()

  const { userRole, userLastSearch, updateUserLastSearch } = useUserContext()
  const [readPermission, setReadPermission] = useState<Permission>({})
  const [createPermission, setCreatePermission] = useState<Permission>({})
  const [editPermission, setEditPermission] = useState<Permission>({})
  const [deletePermission, setDeletePermission] = useState<Permission>({})
  const [file, setFile] = useState()
  const [array, setArray] = useState<object[]>([])
  const [totalAnswers, setTotalAnswers] = useState(50)
  const [currentPaperDetails, setCurrentPaperDetails] = useState<QuestionAnswer[]>([])
  const [evaluationData, setEvaluationData] = useState<Evaluation[]>([])
  const [current, setCurrent] = useState<number | undefined>(undefined)
  const [pageSize, setPageSize] = useState<number>()
  const [searchValue, setSearchValue] = useState<string>(() => {
    if (persistSearch && userLastSearch?.evaluations) return userLastSearch.evaluations
    return ''
  })
  const fileReader = new FileReader()
  const { show: showEvaluation } = useNavigation()
  useEffect(() => {
    if (userRole !== undefined) {
      setReadPermission(Permissions.can(userRole).readAny('evaluations'))
      setCreatePermission(Permissions.can(userRole).createAny('evaluations'))
      setEditPermission(Permissions.can(userRole).updateAny('evaluations'))
      setDeletePermission(Permissions.can(userRole).deleteAny('evaluations'))
    }
  }, [userRole])

  const refreshTable = () => {
    tableQueryResult?.refetch()
  }
  const { tableProps, sorter, tableQueryResult, setFilters } = useTable<IEvaluationMain>({
    resource: 'evaluations',
    initialPageSize: 10000,
    hasPagination: false,
    initialSorter: [
      {
        field: 'created_at',
        order: 'desc',
      },
    ],
    // initialFilter: [
    //   {
    //     field: 'evaluation_request_id',
    //     operator: 'eq',
    //     value: record?.id,
    //   },
    // ],
    metaData: {
      fields: [
        'id',
        'name',
        'created_at',
        'paper_id',
        'evaluation_request_id',
        { paper: ['subSectionQuestions', 'paper_smart_id', 'paper_id'] },
        { evaluators_assigned: ['id', 'evaluator_id'] },
      ],
    },
  })
  useEffect(() => {
    if (record?.id) {
      setSearchValue('')
      updateUserLastSearch('evaluations', '')
      setFilters([
        {
          field: 'evaluation_request_id',
          operator: 'eq',
          value: record?.id,
        },
      ])
    }
    if (userRole === 'evaluationincharge') {
      setFilters([
        {
          field: 'evaluation_request.evaluation_in_charge',
          operator: 'eq',
          value: user?.id,
        },
      ])
    } else if (userRole === 'deliverymanager') {
      setFilters([
        {
          field: 'evaluation_request.created_by',
          operator: 'eq',
          value: user?.id,
        },
      ])
    }
  }, [record, userRole])

  const roleFilteredData = useMemo(() => {
    let dataToFilter = tableQueryResult?.data?.data || []
    
    // First apply userRole logic
    if (userRole === 'evaluators') {
      dataToFilter = dataToFilter.filter(evaluation => {
        let isEvaluatorMapped = false
        evaluation?.evaluators_assigned?.forEach((evaluationEvaluator: any) => {
          if (evaluationEvaluator?.evaluator_id === user?.id) isEvaluatorMapped = true
        })
        return isEvaluatorMapped
      })
      console.log({ filteredEvaluationData: dataToFilter })
    }
    return dataToFilter
  }, [userRole, tableQueryResult?.data?.data, user?.id])

  const tableData = useMemo(() => {
    if (searchValue) {
      return roleFilteredData.filter((evl: any) => 
        evl.name.toLowerCase().includes(searchValue.toLowerCase())
      )
    }
    return roleFilteredData
  }, [roleFilteredData, searchValue])

  // useEffect(() => {
  //   console.log('tHIS RERENDERS on every tableqyueryresult')
  //   setTableData([])
  // }, [tableQueryResult?.data?.data])

  const {
    formProps,
    modalProps,
    show,
    close: closeModal,
  } = useModalForm({
    resource: 'evaluations',
    action: 'create',
    redirect: false,
  })
  const deleteEvaluation = async (evalDetails: any) => {
    try {
      const deleteEvaluationDetailsById: any = await deleteEvaluationDetails(evalDetails?.id)
      console.log(deleteEvaluationDetailsById, 'evaluation details')
      if (deleteEvaluationDetailsById) {
        message.success('Deleted successfully...')
        tableQueryResult?.refetch()
      } else {
        message.error('Deletion failed')
      }
    } catch (err) {
      console.log(err)
      message.error('Something went wrong please try again later')
    }
  }

  const handleSearchChange = (event: any) => {
    const value = event.target.value
    setSearchValue(value)
    if (persistSearch) {
      updateUserLastSearch('evaluations', value)
    }
  }
  return (
    <List
      title="Evaluations"
      pageHeaderProps={{
        extra: [
          <RefreshButton onClick={() => tableQueryResult?.refetch()} />,
          <>
            {record?.id && record?.status === 'Open' && (
              <CreateButton
                style={{ display: createPermission !== undefined && createPermission?.granted ? 'block' : 'none' }}
                type="primary"
                icon={<PlusOutlined />}
                onClick={() => show()}
              />
            )}
          </>,
        ],
      }}
    >
      {/* -----------SEARCH SECTION */}
      <Row gutter={[24, 16]}>
        <Col xs={24} sm={24} md={10} lg={10} xl={8} style={{ marginBottom: '1rem' }}>
          <Input
            placeholder="Search"
            allowClear
            prefix={<Icons.SearchOutlined style={{ cursor: 'pointer' }} />}
            onChange={handleSearchChange}
            value={searchValue}
          />
        </Col>
      </Row>

      <Table
        {...tableProps}
        dataSource={tableData}
        rowKey="id"
        size="small"
        loading={tableQueryResult?.isFetching}
        pagination={{
          onChange(page, pageSize) {
            setCurrent(page)
            setPageSize(pageSize)
          },
          showSizeChanger: true,
          current: current,
          pageSize: pageSize,
          // total: tableData?.length,
          total: tableData?.length,
          defaultCurrent: 1,
        }}
      >
        <Table.Column
          dataIndex="name"
          title="Name"
          render={(_, data: any) => (
            <>
              <ShowButton
                size="small"
                type="link"
                icon={null}
                recordItemId={data.id}
                onClick={() => {
                  // show()
                  showEvaluation('evaluations', data?.id)
                }}
              >
                <Typography.Text
                  style={{
                    width: 200,
                    textAlign: 'left',
                    color: '#6659FF',
                    cursor: 'pointer',
                  }}
                  ellipsis={{ tooltip: data?.name }}
                >
                  {data?.name}
                </Typography.Text>
              </ShowButton>
            </>
          )}
        />
        <Table.Column
          dataIndex="paper_smart_id"
          title="Paper"
          render={(_, record: any) => <Typography.Text>{`#${record?.paper?.paper_id}-${record?.paper?.paper_smart_id}`}</Typography.Text>}
        />

        <Table.Column
          dataIndex="created_at"
          title="Created At"
          render={value => <DateField value={value} format="LLL" />}
          defaultSortOrder={getDefaultSortOrder('created_at', sorter)}
          sorter
        />
        <Table.Column<IEvaluationMain>
          title="Actions"
          dataIndex="created_at"
          render={(_, record) => (
            <Popconfirm
              title="Are you sure do you want to delete the evaluation details?"
              onConfirm={() => deleteEvaluation(record)}
              okText="Yes"
              cancelText="No"
            >
              <Button icon={<DeleteOutlined />} />
            </Popconfirm>
          )}
        />
      </Table>

      <CreateEvaluation refreshTable={refreshTable} modalProps={modalProps} formProps={formProps} close={closeModal} record={record} />
    </List>
  )
}
